import { combineReducers } from 'redux';

import { stormConfigListReducer } from './listModule';

export default combineReducers({
	list: stormConfigListReducer,
});
